import { render, staticRenderFns } from "./CartBody.vue?vue&type=template&id=44170cf7&scoped=true"
import script from "./CartBody.vue?vue&type=script&lang=ts"
export * from "./CartBody.vue?vue&type=script&lang=ts"
import style0 from "./CartBody.vue?vue&type=style&index=0&id=44170cf7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44170cf7",
  null
  
)

export default component.exports